"use client"

import * as React from "react"
import { Label as LabelPrimitive } from "radix-ui"

import { cn } from "@/lib/utils"
import {LabelOverrideStyle} from "@/components/uiWrappers/componentOverrideStyles.ts"

function Label({
                   className,
                   ...props
               }: React.ComponentProps<typeof LabelPrimitive.Root>) {
    return (
        <LabelPrimitive.Root
            data-slot="label"
            className={cn(
                "gap-2 text-sm leading-none font-medium group-data-[disabled=true]:opacity-50 peer-disabled:opacity-50 flex items-center select-none group-data-[disabled=true]:pointer-events-none peer-disabled:cursor-not-allowed",
                LabelOverrideStyle,
                className
            )}
            {...props}
        />
    )
}

export { Label }
